import { PrinterType } from '@core/services/system/receipt-printers/enum/printer-type.enum';

/**
 * A classified pre-write print failure that keeps the queue's standard retry handling, only with a
 * known reason for the operator. Nothing was printed, so a retry cannot duplicate the receipt.
 */
export class PrinterRetryableError extends Error {
  constructor(
    public readonly printerType: PrinterType,
    public readonly reason: string,
    public readonly originalMessage: string,
    public readonly originalError?: unknown,
    /** True when the Star plugin before 7.3.2 reported this failure as a successful print (iOS). */
    public readonly legacyIosSuccess: boolean = false,
    /**
     * Optional cap on the standard tries budget: once `printingTriesCount` exceeds it, the item
     * fails instead of being retried further.
     */
    public readonly failAfterTries?: number
  ) {
    super(`[${printerType}] Print attempt failed (${reason}): ${originalMessage}`);
    this.name = 'PrinterRetryableError';

    // Preserve prototype chain across the TS down-level emit so that
    // `error instanceof PrinterRetryableError` works reliably at consumer sites.
    Object.setPrototypeOf(this, PrinterRetryableError.prototype);
  }
}
